const getLogoPath = ()=>{
    const subdomain = window.location.host.split('.')[0];
    if(subdomain.indexOf('localhost')>-1)
        return window.location.origin+"/images/logo.png";
    else
        return window.location.origin+"/images/"+subdomain+"-logo.png";

}

const onlyOfficeUser = ()=>{
    function parseJwt (token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    
        return JSON.parse(jsonPayload);
    }
    var token = window.localStorage.getItem('eventsafeguardtoken');
    if(token){
        const encodedJwt = parseJwt(token);
        if(encodedJwt.isSupplier){
            window.location='/supplier-events';
            return;
        }
    }
}

const getCompanyUniqueKey = ()=>{
    const subdomain = window.location.host.split('.')[0];
    if(subdomain.indexOf('localhost')>-1)
        return "1000000000";
    else if(subdomain=="scor")
        return "4b86a847304742258c0feb688453ccf2";
    else if(subdomain=="elze")
        return "3286a847304742258c0feb688453ccf2";
    else if(subdomain=="performans")
        return "4234a847304742258c0fe458453ccf2";
    else if(subdomain=="orko")
        return "2000000000";
    else if(subdomain=="soymet")
        return "345bcdc2954d78cf903827dd9f76b644";
    else if(subdomain=="forum")
        return "019bcdc2954d78cf903827dd9f76b692";
    else if(subdomain=="eksen")
        return "eksendc2954d78cf903827dd9f76b692";
    else if(subdomain=="sesa")
        return "sesadc2564d78cf903827dd9f76b692"; 
    else if(subdomain=="prosedur")
        return "prosdc2564d78cf903827dd9f76b692";
    else if(subdomain=="bronz")
        return "bronz2564d78cf903827dd9f76b6392";
    else
        return "1000000000";

}

module.exports = { getLogoPath, getCompanyUniqueKey, onlyOfficeUser }